'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@repo/ui/components';
import { House } from '@repo/ui/icons';

/**
 * Vendor-independent error page UI.
 *
 * Telemetry reporting is composed by app-owned error files (e.g. via
 * `useReportErrorOnce` from `@repo/analytics/sentry/react`); this component
 * has no auth, Sentry, or other vendor side effects.
 */
export const ErrorPage = t0 => {
  const $ = _c(8);
  const {
    reset
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <h1 className="text-5xl font-bold text-foreground">Something went wrong</h1>;
    t2 = <p className="text-lg text-muted-foreground">Sorry, we couldn't load the page. Please try again or navigate back home.</p>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== reset) {
    t3 = <Button onClick={reset} variant="outline" data-sentry-element="Button" data-sentry-source-file="page.tsx">Try again</Button>;
    $[2] = reset;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <a href="/" />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Button render={t4} variant="outline" data-sentry-element="Button" data-sentry-source-file="page.tsx"><House data-sentry-element="House" data-sentry-source-file="page.tsx" /> Go back home</Button>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t3) {
    t6 = <div className="flex h-svh w-full flex-col items-center justify-center gap-8" data-sentry-component="ErrorPage" data-sentry-source-file="page.tsx">{t1}{t2}<div className="flex gap-2">{t3}{t5}</div></div>;
    $[6] = t3;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  return t6;
};